import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { ColorModeTextPropKeys } from 'src/app/styles/colors';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

interface FooterLinksStackProps {
  flex?: string;
  textColor?: ColorModeTextPropKeys;
}

export const FooterLinksStack = styled(Stack)<FooterLinksStackProps>`
  flex: ${({ flex }) => flex || '1 1 auto'};
  height: 100%;
  --svg-fill: ${({ textColor }) => cssVar(textColor)};

  &:hover {
    --svg-fill: ${({ textColor }) => cssVar(textColor)};
  }

  .footer-link,
  .footer-group {
    justify-content: flex-start;
  }

  .footer-link {
    font-weight: ${cssVar('font-weight-regular')};
    color: ${cssVar('text-primary-on-brand')};
  }
`;
